module.exports = {
          srcSet: __webpack_public_path__ + "public/images/7ea0bdea1df02d15ebb6bfe27f1e9ae1-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/7ea0bdea1df02d15ebb6bfe27f1e9ae1-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/7ea0bdea1df02d15ebb6bfe27f1e9ae1-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/7ea0bdea1df02d15ebb6bfe27f1e9ae1-1774.webp"},
          
          width: 1774,
          height: 887
        }